import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';


export interface DataSetModel {
	data: any[]
}

export interface TableBarChartModel {
	graph: {
		labels: any[],
		datasets: DataSetModel[],
		barPosition: number[],
		graphID?: string,
		graphTitle?: string
	},
	all?: any[]
}
@Component({
	selector: 'app-table-chart',
	templateUrl: './table-chart.component.html',
	styleUrls: ['./table-chart.component.scss']
})
export class TableChartComponent implements OnInit {

	@Input() tableData: TableBarChartModel;
	@Input() barColor = '0 145 234';
	@Input() tableOutlineColor = '238 238 238';
	@Input() positions: any = [];
	@Input() detailPositions: any = [];
	@Input() filterPositions: any = [];

	@Output() positionEmit = new EventEmitter();

	indexArr: Array<Number> = [];
	detailIndexArr: Array<Number> = [];
	filterIndexArr: Array<Number> = [];

	constructor() { }

	ngOnInit(): void {
	}

	ngOnChanges(changes) {
		if (changes.positions && changes.positions.currentValue) {
			this.indexArr = changes.positions.currentValue.map(resp => {
				return resp.index;
			});
		}
		if (changes.detailPositions && changes.detailPositions.currentValue) {
			this.detailIndexArr = changes.detailPositions.currentValue.map(resp => {
				return resp.index;
			});
		}
		if (changes.filterPositions && changes.filterPositions.currentValue) {
			this.filterIndexArr = changes.filterPositions.currentValue.map(resp => {
				return resp.index;
			});
		}
	}

	detail(data, dataset, additionalInfo: any = {}) {
		if (additionalInfo.type === 'bar' && this.positions && this.positions.length) {
			const position = this.positions.find(items => items.index === additionalInfo.dataIndex);
			if (position) {
				this.positionEmit.emit(
					{
						position,
						data: {
							value: data,
							rowData: dataset
						}
					}
				);
			}
		} else if (additionalInfo.type === 'content' && this.detailPositions && this.detailPositions.length) {
			const position = this.detailPositions.find(items => items.index === additionalInfo.dataIndex);
			if (position) {
				this.positionEmit.emit(
					{
						position,
						data: {
							value: data,
							rowData: dataset
						},
						rowIndex: additionalInfo.rowIndex
					}
				);
			}
		}
	}

	getFilter(filterData, additionalInfo: any = {}) {
		if (this.filterPositions && this.filterPositions.length) {
			if (additionalInfo.filterType === 'sort') {
				this.filterPositions.forEach((filterData, filterIndex) => {
					if (filterIndex !== additionalInfo.index) {
						filterData.descending = false;
						filterData.ascending = false;
					}
				});

				if (!filterData.ascending && !filterData.descending) {
					filterData.ascending = true;
				} else if (filterData.ascending) {
					filterData.ascending = false;
					filterData.descending = true;
				} else if (filterData.descending) {
					filterData.ascending = true;
					filterData.descending = false;
				}
				this.positionEmit.emit(filterData);
			}
			// const position = this.filterPositions.find(items => items.index === additionalInfo.dataIndex);
			// if (position) {
			// 	this.positionEmit.emit(
			// 		{
			// 			position,
			// 			data: {
			// 				value: data,
			// 				rowData: dataset
			// 			},
			// 			rowIndex: additionalInfo.rowIndex
			// 		}
			// 	);
			// }
		}
	}

}
